module.exports = __webpack_public_path__ + "img/common.8440ee75.png";